import { roles } from "helpers/enums";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import React from "react";
import { getOrganizationNames } from "sources/admin";

const config = {
    header: {
        label: "Название",
        inputProps: { name: "header" },
        validators: [requiredField],
        required: true,
    },
    text: {
        label: "Текст уведомления",
        inputProps: { name: "text" },
        validators: [requiredField],
        required: true,
    },
    noWayToClose: {
        label: "Без возможности закрытия",
        inputProps: { name: "noWayToClose" },
        checkbox: true,
    },
    organizationBlockDate: {
        label: "Дата блокировки организации",
        inputProps: { name: "organizationBlockDate", type: "date" },
    },
    organizationIds: {
        // select
        label: "Организации",
        inputProps: { name: "organizationIds" },
        url: getOrganizationNames,
        propName: "name",
        menuPortalTarget: document.body,
        menuPlacement: "top",
        isMulti: true,
    },
    userIds: {
        // select
        label: "Пользователи",
        inputProps: { name: "userIds" },
        propName: "fullNameOrEmail",
        options: [],
        menuPortalTarget: document.body,
        menuPlacement: "top",
        isMulti: true,
        placeholder: <small>Всем пользователям</small>,
    },
    roles: {
        // select
        label: "Роли",
        inputProps: { name: "roles" },
        options: roles,
        menuPortalTarget: document.body,
        menuPlacement: "top",
        isMulti: true,
        placeholder: <small>Всем ролям</small>,
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
